import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { ApplyDropdown } from './ApplyDropdown';
import { LANDING_IMAGES } from '../../lib/landingImages';

export const CTAV2 = ({ onApplySelect }) => {
  const { t } = useTranslation();

  return (
    <section className="relative py-24 sm:py-32 overflow-hidden" data-testid="v2-cta">
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[500px] rounded-full blur-[140px] bg-fuchsia-700/25 animate-neon-pulse dark:lg:opacity-40 dark:opacity-0 opacity-0 lg:opacity-100" />
        <div className="absolute top-0 right-0 w-[400px] h-[400px] rounded-full blur-[120px] bg-orange-600/20 dark:lg:opacity-30 dark:opacity-0 opacity-0 lg:opacity-100" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full blur-[120px] bg-indigo-700/25 dark:lg:opacity-30 dark:opacity-0 opacity-0 lg:opacity-100" />
      </div>
      <div className="absolute inset-0 neon-grid-bg opacity-30 dark:lg:opacity-0 lg:opacity-0 dark:opacity-0" />

      {/* Mobile dark background image */}
      <img
        {...LANDING_IMAGES.ctaMobileDark}
        sizes="100vw"
        alt=""
        aria-hidden="true"
        loading="lazy"
        decoding="async"
        className="hidden dark:block dark:lg:hidden absolute inset-0 w-full h-full object-cover object-center pointer-events-none"
        data-testid="v2-cta-bg-mobile-dark"
      />
      {/* Mobile light background image */}
      <img
        {...LANDING_IMAGES.ctaMobileLight}
        sizes="100vw"
        alt=""
        aria-hidden="true"
        loading="lazy"
        decoding="async"
        className="block lg:hidden dark:hidden absolute inset-0 w-full h-full object-cover object-center pointer-events-none"
        data-testid="v2-cta-bg-mobile-light"
      />
      <div className="lg:hidden absolute inset-0 pointer-events-none bg-gradient-to-b from-background/60 via-background/30 to-background/60" />

      {/* Desktop dark background image */}
      <img
        {...LANDING_IMAGES.ctaDark}
        sizes="100vw"
        alt=""
        aria-hidden="true"
        loading="lazy"
        decoding="async"
        className="hidden lg:dark:block absolute inset-0 w-full h-full object-cover object-center pointer-events-none"
        data-testid="v2-cta-bg-dark"
      />
      <div className="hidden lg:dark:block absolute inset-0 pointer-events-none bg-gradient-to-b from-background/70 via-background/40 to-background/70" />

      {/* Desktop light background image */}
      <img
        {...LANDING_IMAGES.ctaLight}
        sizes="100vw"
        alt=""
        aria-hidden="true"
        loading="lazy"
        decoding="async"
        className="hidden lg:block dark:lg:hidden absolute inset-0 w-full h-full object-cover object-center pointer-events-none"
        data-testid="v2-cta-bg-light"
      />
      <div className="hidden lg:block dark:lg:hidden absolute inset-0 pointer-events-none bg-gradient-to-b from-background/60 via-background/30 to-background/60" />

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="font-heading font-bold text-4xl sm:text-6xl lg:text-7xl text-foreground leading-[1.0] tracking-tight"
        >
          {t('v2_cta_title')}
          <br />
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-fuchsia-400 via-purple-500 to-orange-400 neon-text-purple">
            {t('v2_cta_title_accent')}
          </span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.15 }}
          className="mt-7 text-foreground/65 text-base sm:text-lg max-w-2xl mx-auto"
        >
          {t('v2_cta_sub')}
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.25 }}
          className="mt-10 flex justify-center"
        >
          <ApplyDropdown onSelect={onApplySelect} size="lg" testIdPrefix="v2-cta-apply" />
        </motion.div>
      </div>
    </section>
  );
};
